const Committee = () => {
    return (
        <div id="committee" className="vision-card">
            <h3>COMMITTEE & MEMBERS</h3>
            <p>
                Management Committee, Academic Council, Discipline Committee,
                Sports Committee, Cultural Committee, and Parent Coordination Team.
            </p>
        </div>
    );
};

export default Committee;